import React from "react";
import { I18n } from "aws-amplify";

import ForgotPassword from "aws-amplify-react/lib/Auth/ForgotPassword";
import { FormSection, FormField, SectionHeader, SectionBody, SectionFooter, Button, Link, Input, InputLabel, SectionFooterPrimaryContent, SectionFooterSecondaryContent } from "aws-amplify-react/lib/Amplify-UI/Amplify-UI-Components-React";
import { auth } from "aws-amplify-react/lib/Amplify-UI/data-test-attributes";

export default class CustomForgotPassword extends ForgotPassword {
  showComponent(theme) {
    const { hide = [], authData = {} } = this.props;
    if (hide.includes(ForgotPassword)) {
      return null;
    }

    const isSubmitStep = !!(this.state.delivery || authData.username);
    const fieldStyle = {
      width: "100%",
      maxWidth: "260px",
    };
    const inputStyle = {
      width: "100%",
      maxWidth: "260px",
      minHeight: "38px",
      padding: "0.45rem 0.75rem",
      boxSizing: "border-box",
    };

    return (
      <FormSection theme={theme} data-test={auth.forgotPassword.section}>
        <SectionHeader theme={theme} data-test={auth.forgotPassword.headerSection}>
          {I18n.get("Reset your password")}
        </SectionHeader>

        <SectionBody theme={theme} data-test={auth.forgotPassword.bodySection}>
          {isSubmitStep ? (
            <>
              <FormField theme={theme} style={fieldStyle}>
                <InputLabel theme={theme}>{I18n.get("Code")} *</InputLabel>
                <Input placeholder={I18n.get("Code")} theme={theme} key="code" name="code" autoComplete="off" onChange={this.handleInputChange} style={inputStyle} />
              </FormField>
              <FormField theme={theme} style={fieldStyle}>
                <InputLabel theme={theme}>{I18n.get("New Password")} *</InputLabel>
                <Input placeholder={I18n.get("New Password")} theme={theme} type="password" key="password" name="password" autoComplete="off" onChange={this.handleInputChange} style={inputStyle} />
              </FormField>
            </>
          ) : (
            <FormField theme={theme} style={fieldStyle}>
              <InputLabel theme={theme}>{I18n.get("Username")} *</InputLabel>
              <Input placeholder={I18n.get("Username")} theme={theme} key="username" name="username" autoComplete="username" onChange={this.handleInputChange} defaultValue={authData.username || ""} style={inputStyle} />
            </FormField>
          )}
        </SectionBody>

        <SectionFooter theme={theme} data-test={auth.forgotPassword.footerSection} className="auth-screen__forgot-password-footer" style={{ display: "flex", alignItems: "center", gap: "0.55rem", flexWrap: "wrap" }}>
          <SectionFooterPrimaryContent theme={theme}>
            {isSubmitStep ? (
              <Button theme={theme} onClick={this.submit} data-test={auth.forgotPassword.submitButton}>
                {I18n.get("Submit")}
              </Button>
            ) : (
              <Button theme={theme} onClick={this.send} data-test={auth.forgotPassword.sendCodeButton}>
                {I18n.get("Send Code")}
              </Button>
            )}
          </SectionFooterPrimaryContent>

          <SectionFooterSecondaryContent theme={theme} className="auth-screen__forgot-password-secondary">
            {isSubmitStep ? (
              <>
                <span className="auth-screen__forgot-password-separator" aria-hidden="true">
                  {" "}
                </span>
                <Link theme={theme} onClick={this.send} data-test={auth.forgotPassword.resendCodeLink}>
                  {I18n.get("Resend Code")}
                </Link>
              </>
            ) : (
              <>
                <span className="auth-screen__forgot-password-separator" aria-hidden="true">
                  {" "}
                </span>
                <Link theme={theme} onClick={() => this.changeState("signIn")} data-test={auth.forgotPassword.backToSignInLink}>
                  {I18n.get("Back to Sign In")}
                </Link>
              </>
            )}
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}
